/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createEntity } from 'jotai/entity';
import { WorkspaceObject } from '../WorkspaceObject';

export const blankWorkspace: WorkspaceObject = {
  id: 'blank',
  name: 'Blank Workspace',
  slug: 'blank',
  owner: 'system',
  activeView: 't1',
  views: {
    byId: {
      t1: { id: 't1', name: 'Primary View', visualizations: [], layouts: 'vl1' },
    },
    allIds: ['t1'],
  },
  viewLayouts: {
    byId: {
      vl1: [],
    },
    allIds: ['vl1'],
  },
  visualizations: {
    byId: {},
    allIds: [],
  },
  visualizationSettings: {
    byId: {},
    allIds: [],
  },
  selectedCompetitorGroups: {},
  competitorGroups: createEntity(),
  competitorGroupVehicles: createEntity(),
  selectedReferenceVehicle: createEntity(),
  hideFooter: false,
  trackMapSettings: createEntity(),
};
